import { figmaColors } from '@doltech/ui/lib/figma/colors';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { ImageAlignEnum } from '@doltech/ui/lib/figma/DolEditor/components/ImageResizableAlignable/ImageAlignEnum';
import { ImageResizableAlignable } from '@doltech/ui/lib/figma/DolEditor/components/ImageResizableAlignable/ImageResizableAlignable';
import { InputBlank } from '@doltech/ui/lib/figma/DolEditor/components/InputBlank/InputBlank';
import { useDeviceDetect } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { TestModeEnum } from '@doltech/utils/lib/constants';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { defaultSlateValue } from '../../../question-data-model/SlateObj/slate-editor.store';
import {
  DiagramLabelExtraQuestionProps,
  ResultDiagramLabelQuestionInstance,
} from '../../model/Question/result-diagram-label-question.store';

const Main = styled(Box)`
  position: relative;
  .ant-spin-nested-loading {
    width: auto;
  }
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: ${figmaColors.text1};
  }
  .sub-title {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    display: flex;
    align-items: center;

    color: ${figmaColors.neutral3};
  }
  .diagram-content {
    margin-top: 12px;
  }
  .wrapper-blank-editor {
    display: flex;
    flex-direction: row;
    width: 100%;

    .input-blank {
      flex: 1;
      width: 100%;
      .dol-editor {
        width: 100%;
        .editor-editable-plugins {
          background-color: transparent;
          border: none;
        }

        .editor-content-wrapper {
          margin-top: 0;
        }
      }
    }

    &.${ImageAlignEnum.ALIGN_CENTER} {
      flex-direction: column;
      align-items: center;
    }

    &.${ImageAlignEnum.ALIGN_RIGHT} {
      flex-direction: row-reverse;
    }
  }
`;

export interface DiagramLabelCompletionResultProps extends React.HTMLAttributes<HTMLDivElement> {
  data: ResultDiagramLabelQuestionInstance & DiagramLabelExtraQuestionProps;
  goToQuestion: (questionNo, isScroll) => void;
  testMode: TestModeEnum;
}

export const DiagramLabelCompletionQuestionResult = observer(
  (props: DiagramLabelCompletionResultProps) => {
    const { data, goToQuestion, testMode, ...rest } = props;
    const { baseNo, userAnswers, correctAnswers, marked, nodeImage, nodeBlanks, index } = data;
    const { isDesktop } = useDeviceDetect();
    const imageAlign = isDesktop ? nodeImage?.align : ImageAlignEnum.ALIGN_CENTER;
    return (
      <Main {...rest}>
        <div className={cl('wrapper-blank-editor', { [imageAlign]: true })}>
          <ImageResizableAlignable
            spots={nodeImage.spots.map((spot) => {
              const text = baseNo + Number(spot.text) - 1;
              return {
                ...spot,
                text,
              };
            })}
            imageWidth={nodeImage?.width}
            currentAlignment={imageAlign}
            url={nodeImage?.image?.url}
            readOnly
          />
          <InputBlank
            initialValue={nodeBlanks?.[0]?.getEditorValue() || defaultSlateValue}
            initBlanks={nodeBlanks?.[0]?.blanks || []}
            userAnswers={correctAnswers.map((co) => {
              const { blankId } = co;
              const userAnswerFound = userAnswers.find((ua) => ua.blankId === blankId);
              const markedStatus = marked[co.key];
              return {
                blankId,
                userAnswer: userAnswerFound?.userAnswer,
                correctAnswer: co.value,
                markedStatus,
              };
            })}
            withToolbar={undefined}
            questionNo={baseNo}
            mode={testMode}
            selectBlankIndex={index}
            onClickBlank={goToQuestion}
            readOnly
            className="input-blank"
          />
        </div>
      </Main>
    );
  }
);
